export default __webpack_public_path__ + "static/media/dematFolioPopupIcon.3e968213.svg";